export default "__VITE_ASSET__e658b765__"